var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M11.5 9.6L11.5 6.4 15.5 4.3 15.5 11.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M15,5.1v5.7l-3-1.5V6.7L15,5.1 M16,3.5l-5,2.6v3.9l5,2.6V3.5L16,3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M2.5,12.5c-1.1,0-2-0.9-2-2v-5c0-1.1,0.9-2,2-2h7c1.1,0,2,0.9,2,2v5c0,1.1-0.9,2-2,2H2.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M9.5,4C10.3,4,11,4.7,11,5.5v5c0,0.8-0.7,1.5-1.5,1.5h-7C1.7,12,1,11.3,1,10.5v-5 C1,4.7,1.7,4,2.5,4H9.5 M9.5,3h-7C1.1,3,0,4.1,0,5.5v5C0,11.9,1.1,13,2.5,13h7c1.4,0,2.5-1.1,2.5-2.5v-5C12,4.1,10.9,3,9.5,3 L9.5,3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M7.5 -1.9H8.5V17.900000000000002H7.5z",
    transform: "rotate(-45.001 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video--off.0d8e9a8ed46d620746b1355a5005544d.svg";
export { ForwardRef as ReactComponent };